<template>
<Auth>
  <TaskForm></TaskForm>
</Auth>
</template>

<script>
import TaskForm from './TaskForm.vue';
import Auth from './Auth.vue';
export default {
  name: 'admin',
  components: {TaskForm, Auth}
}
</script>



// WEBPACK FOOTER //
// src/components/Admin.vue